import React from "react";
import { Route, Routes } from "react-router-dom";
import { SEOProvider } from "./context/SEOContext";
import Contact from "./views/Contact/Contact";
import Home from "./views/Home/Home";
import UserLogin from "./views/UserLogin/UserLogin";
import Wishlist from "./views/Wishlist/Wishlist";
import NotFound from "./views/NotFound/404";
import Faq from "./views/Faq/Faq";
import FaqDetail from "./views/FaqDetail/FaqDetail";
import CategoryDetailPage from "./views/CategoryDetailPage/CategoryDetailPage";
import FaqCategoryDetail from "./views/FaqCategoryDetail/FaqCategoryDetail";
import SubCategoryDetailPage from "./views/SubCategoryDetailPage/SubCategoryDetailPage";
import Blog from "./views/Blog/Blog";
import Profile from "./views/Profile/Profile";
import CreatAccount from "./views/CreatAccount/CreatAccount";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import ChangePassword from "./views/ChangePassword/ChangePassword";
import Shop from "./views/Shop/Shop";
import ProductDetail from "./views/ProductDetail/ProductDetail";
import Cart from "./views/Cart/Cart";
import Checkout from "./views/Checkout/Checkout";
import UserAddressInfo from "./views/UserAddressInfo/UserAddressInfo";
import UserOrders from "./views/UserOrders/UserOrders";
import About from "./views/About/About";
import { PriceFormatProvider } from "./components/PriceFormat/PriceFormat";
import PayPalSuccess from "./views/PaypalSuccess/PaypalSuccess";
import MapWithSearch from "./views/MapWithSearch/MapWithSearch";
import OrderLookup from "./views/OrderLookup/OrderLookup";
import SecureShoppingInformation from "./views/SecureShoppingInformation/SecureShoppingInformation";
import TermsAndConditions from "./views/TermsAndConditions/TermsAndConditions";
import ShippingAndDelivery from "./views/ShippingAndDelivery/ShippingAndDelivery";
import PrivacyPolicy from "./views/PrivacyPolicy/PrivacyPolicy";
import "./App.css";
import ProductLang from "./views/ProductLang/ProductLang";

import "leaflet/dist/leaflet.css"; // ← Bunu ekle
import FaqCategoryDetailPage from "./views/FaqCategoryDetailPage/FaqCategoryDetailPage";
import Perfume from "./views/Perfume/Perfume";
import MukemelPerfume from "./views/MukemelPerfume/MukemelPerfume";
import InstallmentOptions from "./views/InstallmentOptions/InstallmentOptions";
import ReturnPolicy from "./views/ReturnPolicy/ReturnPolicy";
import Application from "./views/Application/Application";
import Ar from "./views/Ar/Ar";

function App() {
  return (
    <SEOProvider>
      <PriceFormatProvider>
        <Routes>
          {/* Home Page */}
          <Route path="/" element={<Home />} />
          {/* Shop Page page */}
          <Route path="/shop" element={<Shop />} />
          {/* Product Detail Page page */}
          <Route path="/product/:id" element={<ProductDetail />} />
          {/* Perfume URL */}
          <Route path="/product/mukemel-perfume" element={<MukemelPerfume />} />
          {/* Contact Page */}
          <Route path="/contact" element={<Contact />} />
          {/* UserLogin Page */}
          <Route path="/userlogin" element={<UserLogin />} />
          {/* Wishlist Page */}
          <Route path="/wishlist" element={<Wishlist />} />
          {/* Category Name Page */}
          <Route path="/category/:name" element={<CategoryDetailPage />} />
          {/* Sub Category Name Page */}
          <Route
            path="/:categoryName/:subcategoryName"
            element={<SubCategoryDetailPage />}
          />
          {/* faq page */}
          <Route path="/faq" element={<Faq />} />
          {/* faq sub */}
          <Route
            path="/faq/:category/:faqId"
            element={<FaqCategoryDetailPage />}
          />
          {/* Faq category detail page */}
          <Route path="/:category" element={<FaqCategoryDetail />} />
          {/* Faq question detail page */}
          <Route path="/:category/:faqId" element={<FaqDetail />} />
          {/* Blog page */}
          <Route path="/blog" element={<Blog />} />
          {/* MyProfile page */}
          <Route
            path="/profile/:id"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          {/* User ChangePassword page */}
          <Route
            path="/profile/:id/changepassword"
            element={<ChangePassword />}
          />
          {/* User Address page */}
          <Route
            path="/profile/:id/useraddressinfo"
            element={<UserAddressInfo />}
          />
          {/* User Orders page */}
          <Route path="/profile/:id/userorders" element={<UserOrders />} />
          {/* MyProfile page */}
          <Route path="/createaccount" element={<CreatAccount />} />
          {/* Cart page */}
          <Route path="/cart" element={<Cart />} />
          {/* Checkout page */}
          <Route path="/checkout" element={<Checkout />} />
          {/* About Page page */}
          <Route path="/about" element={<About />} />
          <Route
            path="/secure-shopping-information"
            element={<SecureShoppingInformation />}
          />
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />
          <Route
            path="/shipping-and-delivery"
            element={<ShippingAndDelivery />}
          />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          {/* PaypalSuccess Page page */}
          <Route path="/paypalsuccess" element={<PayPalSuccess />} />
          <Route path="/mapwithsearch" element={<MapWithSearch />} />
          <Route path="/order/:id" element={<OrderLookup />} />
          <Route path="/perfume" element={<Perfume />} />
          <Route path="/application" element={<Application />} />
          <Route path="/ar/:id" element={<Ar />} />

          <Route path="/productlang" element={<ProductLang />} />
          <Route path="/installment-options" element={<InstallmentOptions />} />
          <Route path="/return-policy" element={<ReturnPolicy />} />
          {/* 404 page */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </PriceFormatProvider>
    </SEOProvider>
  );
}

export default App;
